<template>
    <div class="reader-nav-bottom">
        <div class="bi-title">
            <strong>{{ selectedBook.title }}</strong>
            <span> Book Insight</span>
        </div>
        <div class="container">
            <div class="row">
                <div class="reader-player-container ml-auto col-12 col-md-8 col-lg-6 mr-auto">
                    <player-interface :is-main-player="false" :show-title="false" />
                </div>
            </div>
        </div>
        <a href="#" class="reader-close" @click.prevent="$emit('hide-bottom-player')">
            <img src="@assets/img/x-gray.svg" alt="Close reader mode" width="20px">
        </a>
    </div>
</template>

<script>
import { mapState } from "vuex";

export default {
    name: "ReaderNavBottom",
    components: {
        playerInterface: () => import(/* webpackChunkName: "player-interface"*/ "@c/audio-player/player-interface")
    },
    computed: {
        ...mapState({
            selectedBook: state => state.NonfictionReader.bookInsight
        }),
        selectedBookInsightTitle() {
            return "";
        }
    }

}
</script>

<style lang="scss">
    .reader-nav-bottom {
        bottom: 0;
        padding: 8px 30px;
        z-index: 4;
        position: fixed;
        width: 100%;
        background-color: $dark-gray;
        box-shadow: 0 0 0 0 #edf2f1;
        transition: box-shadow .5s;
        border-top: 1px solid #636363;
        display: flex;
        align-items: center;

        @media (max-width: $xl) {
            padding: 8px 0;
        }

        .bi-title {
            position: absolute;

            @media (max-width: $xl) {
                display: none;
            }

            strong {
                color: white;
                font-weight: 600;
                font-size: 22px;
            }

            span {
                color: white;
                font-size: 17px;
                opacity: .6;
            }
        }

        .reader-player-container {
            @media (max-width: $md) {
                padding-left: 3px;
                padding-right: 35px;
            }

            .reader-player {
                padding: 5px 0;
                margin: 0 auto;
                box-shadow: 0 2px 2px 0 rgba(0, 0, 0, 0.03);
                border-radius: 6px;

                .burger-menu {
                    padding-left: 20px;
                    padding-right: 20px;

                    .themes-player-dropdown {
                        .bp-dropdown__btn {
                            width: 25px;
                            height: 20px;
                            display: flex;
                            align-content: center;
                            justify-content: center;

                            .themes-menu {
                                width: 20px;
                            }

                            .themes-close {
                                width: 15px;
                                margin: 0 auto;
                            }
                        }

                        .bp-dropdown__body {
                            top: initial !important;
                            bottom: 50px !important;
                            box-shadow: 0 -5px 10px -3px rgba(0, 0, 0, 0.09);
                            border-bottom-left-radius: 0;
                            border-bottom-right-radius: 0;

                            // Todo: This is not a good solution for mobile theme pills be full width, change this later
                            //for a more scalable and reliable implementation
                            .col-12 {
                                flex-basis: initial;
                            }
                        }
                    }
                }

                .theme-name {
                    @media (max-width: $sm) {
                        display: none !important;
                    }
                }

                .speed {
                    padding-right: 20px !important;
                }

                .player-controls {

                    .rewind,
                    .forward {
                        svg {
                            width: 26px;
                        }
                    }

                    .play-button-bg {
                        width: 42px !important;
                        height: 42px !important;

                        svg {
                            width: 26px;
                        }
                    }
                }
            }
        }

        .reader-close {
            position: absolute;
            right: 30px;

            @media (max-width: $md) {
                right: 0;
                width: 35px;
                height: 100%;
                display: flex;
                align-items: center;
                justify-content: center;

                img {
                    width: 15px;
                }
            }
        }
    }
</style>
